import { gsap } from 'gsap';
import { init, enter, leave } from '../animations';

export function introEnter(el) {
  // const bg = el.querySelector('.ui-intro__bg');
  const content = el.querySelector('.content__text');
  const button = el.querySelector('.content__button');
  const share = el.querySelector('.content__share');
  const cookie = document.querySelector('.cookie-bar');
  const tl = gsap.timeline();

  init.get('fade')(content, { y: 30 });
  init.get('buttonRounded')(button);

  tl.addLabel('start')
    .add(enter.get('fade')(content, 0, 0.75), share ? 'start+=0.3' : 'start+=0.4')
    .add(enter.get('buttonRounded')(button), share ? 'start+=1.3' : 'start+=0.7');

  if (share) {
    const table = el.querySelector('.content__table');
    const shareText = share.querySelector('.share-button__caption');
    const shareButton = share.querySelector('.share-button__button');
    init.get('fade')(shareText, { y: 30 });
    init.get('buttonCircular')(shareButton);
    init.get('fade')(table, { y: 30 });

    tl.add(enter.get('fade')(shareText, 0, 0.75), 'start+=0.6')
      .add(enter.get('buttonCircular')(shareButton), 'start+=0.7')
      .add(enter.get('fade')(table, 0, 0.75), 'start+=1');
  }

  if (cookie) {
    init.get('fade')(cookie, { y: 20 });
    tl.add(enter.get('fade')(cookie, 0, 0.75), 'start+=1');
  }

  return tl;
}

export function introLeave(el) {
  const cookie = document.querySelector('.cookie-bar');
  const content = el.querySelector('.content__text');
  const button = el.querySelector('.content__button');
  const share = el.querySelector('.content__share');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .add(leave.get('fade')(content, { y: -30 }), share ? 'start' : 'start')
    .add(leave.get('buttonRounded')(button), share ? 'start+=1.1' : 'start+=0.3');

  if (share) {
    const table = el.querySelector('.content__table');
    const shareText = share.querySelector('.share-button__caption');
    const shareButton = share.querySelector('.share-button__button');

    tl.add(leave.get('fade')(shareText, { y: -30 }), 'start+=0.3')
      .add(leave.get('buttonCircular')(shareButton), 'start+=0.5')
      .add(leave.get('fade')(table, { y: -30 }), 'start+=0.8');
  }

  if (cookie) tl.to(cookie, { opacity: 0, ease: 'power3.easeOut', duration: 0.75 }, 'start');

  return tl;
}
